/**
 *  社媒平台 点赞、评论、分享 数量格式化
 *  数据展示规则：
 *  ＜1000：显示实际数值；
 *  1000~999999：显示为x.xk，向下取小数点后一位，小数位为0时省略
 *  1000000~+∞：显示为x.xM，向下取小数点后一位，小数位为0时省略
 *
 * @export
 * @param {number} num
 * @return {*}
 */
export function formatPlatformNum(num: number) {
  if (num < 1000) {
    return num;
  }

  if (num >= 1000 && num < 1000000) {
    const platformNum = Math.floor(num / 100) / 10;
    return `${Number.isInteger(platformNum) ? platformNum : platformNum.toFixed(1)}k`;
  }
  const platformNum = Math.floor(num / 100000) / 10;
  return `${Number.isInteger(platformNum) ? platformNum : platformNum.toFixed(1)}M`;
}
